import endpoints from "../services/endpoints";

const actions = {

  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth({commit}, width) {
    commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
  },

  // VxAutoSuggest
  updateStarredPage({commit}, payload) {
    commit('UPDATE_STARRED_PAGE', payload)
  },

  // The Navbar
  arrangeStarredPagesLimited({commit}, list) {
    commit('ARRANGE_STARRED_PAGES_LIMITED', list)
  },
  arrangeStarredPagesMore({commit}, list) {
    commit('ARRANGE_STARRED_PAGES_MORE', list)
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay({commit}) {
    commit('TOGGLE_CONTENT_OVERLAY')
  },
  updateTheme({commit}, val) {
    commit('UPDATE_THEME', val)
  },


  // /////////////////////////////////////////////
  // User/Auth
  // ////////////////////////////////////////////
  async fetchCurrentUser({commit, state}, payload) {
    const {loginUrl} = state
    return await endpoints.API.post(loginUrl, payload).then((res) => {
      let {data: {message: {user, token}}} = res;
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));
      state.user = user;
      commit('FETCH_CURRENT_USER', user)
      let {data: {success}} = res
      return success;
    }).catch((e) => {
      return e.response?e.response.data:e;
    })
  },
  // /////////////////////////////////////////////
  // Events
  // ////////////////////////////////////////////

  //get all events
  async fetchEvents({commit, state}) {
    const {eventsUrl, token} = state
    let eventsResponse = await endpoints.API.get(eventsUrl, {
      headers: {
        Authorization: 'Bearer ' + token //the token is a variable which holds the token
      }
    })
    let {data: {message: {events}}} = eventsResponse
    commit('FETCH_ALL_EVENTS', events)
  },

  async fetchCountReservations({commit, state}, payload) {
    const {countUnconfirmedReservationsUrl, token} = state
    let countReservations = await endpoints.API.get(countUnconfirmedReservationsUrl
      , {
        headers: {
          Authorization: 'Bearer ' + token //the token is a variable which holds the token
        }
      })
    let {data: {message: {reservations}}} = countReservations
    commit('FETCH_COUNT_RESERVATIONS', reservations)
  },

  async fetchCountUpcomingEvents({commit, state}, payload) {
    const {countUpcomingEventsUrl, token} = state
    let countUpcomingEvents = await endpoints.API.get(countUpcomingEventsUrl
      , {
        headers: {
          Authorization: 'Bearer ' + token //the token is a variable which holds the token
        }
      })
    let {data: {message: {events}}} = countUpcomingEvents
    commit('FETCH_COUNT_EVENTS', events)
  },

  async fetchCountUsers({commit, state}, payload) {
    const {countUsersUrl, token} = state
    let countUsers = await endpoints.API.get(countUsersUrl
      , {
        headers: {
          Authorization: 'Bearer ' + token //the token is a variable which holds the token
        }
      })
    let {data: {message: {users}}} = countUsers
    commit('FETCH_COUNT_USERS', users)
  },

  async fetchFooterInfo({commit, state}, payload) {
    const {footerInfoUrl, token} = state
    let footerInfo = await endpoints.API.get(footerInfoUrl
      , {
        headers: {
          Authorization: 'Bearer ' + token //the token is a variable which holds the token
        }
      })
    let {data: {message: {footer}}} = footerInfo
    commit('FETCH_FOOTER_INFO', footer)
  },

  async updateFooterInfo({commit, state}, payload) {
    const {footerInfoUrl, token} = state
    let response = await endpoints.API.put(footerInfoUrl + '/' + payload.id,
      payload
      , {
        headers: {
          Authorization: 'Bearer ' + token //the token is a variable which holds the token
        }
      })
    return response.data.success === true
  },

  async changeUserStatus({commit, state}, payload) {
    const {token} = state
    let response = await endpoints.API.put('v1/admin/user/' + payload.id + '/change-status' ,
      payload
      , {
        headers: {
          Authorization: 'Bearer ' + token //the token is a variable which holds the token
        }
      })
    return response.data.success === true
  },

  async getReservationsByUser({commit, state}, payload) {
    const {reservationsByUserUrl, token} = state
    let response = await endpoints.API.get(reservationsByUserUrl + payload
      , {
        headers: {
          Authorization: 'Bearer ' + token //the token is a variable which holds the token
        }
      })
    let {data: {message: {reservations}}} = response
    commit('RESERVATIONS_BY_USER', reservations)
  },

  async createEvent({commit, state}, payload) {
    const {eventsUrl, token} = state
    let createEventResponse = await endpoints.API.post(eventsUrl,
      payload
      , {
        headers: {
          Authorization: 'Bearer ' + token //the token is a variable which holds the token
        }
      })
    let {data: {success}} = createEventResponse
    commit('CREATE_EVENT', success)
  },

  async deleteEvent({commit, state}, payload) {
    let {eventsUrl, token} = state
    let response = await endpoints.API.delete(eventsUrl + '/' + payload
      , {
        headers: {
          Authorization: 'Bearer ' + token, //the token is a variable which holds the token
        }
      })
    return response.data.success;
  },

  async updateEvent({commit, state}, payload) {
    const {eventsUrl, token} = state
    let response = await endpoints.API.put(eventsUrl + '/' + payload.id,
      payload
      , {
        headers: {
          Authorization: 'Bearer ' + token //the token is a variable which holds the token
        }
      })
    return response.data.success === true
  },


  // /////////////////////////////////////////////
  // Images
  // ////////////////////////////////////////////
  async uploadImages({ commit, state }, images) {
    const { uploadUrl, token } = state; 
    let uploadedImages = [];

    const uploadPromises = images.map(async (image) => {
      const formData = new FormData();
      formData.append(`image`, image.file);
  
      try {
        const response = await endpoints.API.post(uploadUrl, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: 'Bearer ' + token,
          },
        });
        
        uploadedImages.push(response.data);

      } catch (error) {
        console.error('Error uploading images:', error);
      }
    });
  
     await Promise.all(uploadPromises);

      // Returns the uploadedImages array with all successfully uploaded images
     return uploadedImages;
      
  },

  // /////////////////////////////////////////////
  // Locations of the events
  // ////////////////////////////////////////////
  async getAllLocations({commit, state}, payload) {
    let {locationUrl, token} = state
    let getLocations = await endpoints.API.get(locationUrl
      , {
        headers: {
          Authorization: 'Bearer ' + token //the token is a variable which holds the token
        }
      })
    let {data: {message: {locations}}} = getLocations
    commit('FETCH_ALL_LOCATIONS', locations)
  },

  async addLocation({commit, state}, payload) {
    const {locationUrl, token} = state
    try {
      let response = await endpoints.API.post(locationUrl,
        payload
        , {
          headers: {
            Authorization: 'Bearer ' + token //the token is a variable which holds the token
          }
        })
        if (response.data.success) {
          commit('CREATE_LOCATION', payload);
        }
        return response.data.success;
    } catch (error) {
      console.error('Error adding location:', error);
      if (error.response && error.response.status === 422) {
        // Return validation errors
        return {
          success: false,
          errors: error.response.data.errors || error.response.data.message || 'Validation failed'
        };
      }
      return {
        success: false,
        errors: error.response?.data?.message || 'Fehler beim Erstellen des Standorts'
      };
    }
  },

  async updateLocation({commit, state}, payload) {
    const {locationUrl, token} = state
    let response = await endpoints.API.put(locationUrl + '/' + payload.id,
      payload
      , {
        headers: {
          Authorization: 'Bearer ' + token //the token is a variable which holds the token
        }
      })
      if (response.data.success) {
        commit('UPDATE_LOCATION', payload);
      }
      return response.data.success;
  },

  async updateLocationOrder({commit, state}, payload) {
    const {locationUrl, token} = state
    let response = await endpoints.API.post(locationUrl + '/update-order',
      { locations: payload }
      , {
        headers: {
          Authorization: 'Bearer ' + token
        }
      })
      if (response.data.success) {
        commit('UPDATE_LOCATION_ORDER', payload);
      }
      return response.data.success;
  },

  async fetchPendingReservations({commit, state}, payload) {
    commit('FETCH_PENDING_RESERVATIONS', payload)
  },

  async fetchApprovedReservations({commit, state}, payload) {
    commit('FETCH_APPROVED_RESERVATIONS', payload)
  },

  async fetchAllUsers({commit, state}, payload) {
    let {usersUrl, token} = state
    let getAllUsers = await endpoints.API.get(usersUrl
      , {
        headers: {
          Authorization: 'Bearer ' + token //the token is a variable which holds the token
        }
      })
    let {data: {message: {users}}} = getAllUsers
    commit('FETCH_ALL_USERS', users)
  },

  async fetchAllAdmins({commit, state}, payload) {
    let {adminsUrl, token} = state
    let getAllAdmins = await endpoints.API.get(adminsUrl
      , {
        headers: {
          Authorization: 'Bearer ' + token //the token is a variable which holds the token
        }
      })
    let {data: {message: {admins}}} = getAllAdmins
    commit('FETCH_ALL_ADMINS', admins)
  },

  async createAdmin({commit, state}, payload) {
    const {createAdminUrl, token} = state
    let createAdminResponse = await endpoints.API.post(createAdminUrl,
      payload
      , {
        headers: {
          Authorization: 'Bearer ' + token //the token is a variable which holds the token
        }
      })
    let {data: {success}} = createAdminResponse
    return success;
  },

  async deleteAdmin({commit, state}, payload) {
    let {deleteAdminUrl, token} = state
    let response = await endpoints.API.delete(deleteAdminUrl + payload
      , {
        headers: {
          Authorization: 'Bearer ' + token //the token is a variable which holds the token
        }
      })
    return response.data.success;
  },

  async deleteReservation({commit, state}, payload) {
    let {deleteReservationUrl, token} = state
    let response = await endpoints.API.delete(deleteReservationUrl + payload
      , {
        headers: {
          Authorization: 'Bearer ' + token, //the token is a variable which holds the token
        }
      })
    return response.data.success;
  },

  async setSearchString({commit, state}, payload) {
    commit('SET_SEARCH_STRING', payload)
    return payload;
  },

  async setSearchAllString({commit, state}, payload) {
    commit('SET_SEARCH_ALL_STRING', payload)
    return payload;
  },

  async confirmReservation({commit, state}, payload) {
    const {confirmReservationUrl, token} = state
    let response = await endpoints.API.put(confirmReservationUrl + payload.id,
      payload
      , {
        headers: {
          Authorization: 'Bearer ' + token //the token is a variable which holds the token
        }
      })
    return response.data.success;
  },

  async fetchHomeContent({commit, state}, payload) {
    let {contentUrl, token} = state
    let getHomeContent = await endpoints.API.get(contentUrl
      , {
        headers: {
          Authorization: 'Bearer ' + token //the token is a variable which holds the token
        }
      })
    let {data: {message: {contents}}} = getHomeContent
    commit('FETCH_HOME_CONTENTS', contents)
  },

  async updateContent({commit, state}, payload) {
    const {updateContentUr, token} = state
    let response = await endpoints.API.put(updateContentUr + payload.id,
      payload
      , {
        headers: {
          Authorization: 'Bearer ' + token //the token is a variable which holds the token
        }
      })
    return response.data.success === true
  },
  async fetchAllReservations({commit, state}, payload) {
    const {allReservationsUrl, eventsUrl, token} = state
    if (payload && payload.type === 'event' && payload.id) {
      const response = await endpoints.API.get(`${eventsUrl}/${payload.id}`
        , {
          headers: { Authorization: 'Bearer ' + token }
        })
      const {data: {message: {event}}} = response
      const reservations = (event && event.reservations) ? event.reservations : []
      commit('FETCH_ALL_RESERVATIONS', reservations)
      return
    }

    const path = (payload && payload.type === 'user' && payload.id) ? `/user/${payload.id}` : ''
    const allReservations = await endpoints.API.get(allReservationsUrl + path
      , {
        headers: { Authorization: 'Bearer ' + token }
      })
    const {data: {message: {reservations}}} = allReservations
    commit('FETCH_ALL_RESERVATIONS', reservations)
  },

  async fetchAllPendingReservations({commit, state}, payload) {
    const {allReservationsUrl, token} = state
    let allReservations = await endpoints.API.get(allReservationsUrl + '?status=1'
      , {
        headers: {
          Authorization: 'Bearer ' + token
        }
      })
    let {data: {message: {reservations}}} = allReservations
    commit('FETCH_ALL_PENDING_RESERVATIONS', reservations)
    return reservations;
  },

  async fetchPendingReservationsPage({commit, state}, payload) {
    const {allReservationsUrl, token} = state
    const page = payload && payload.page ? payload.page : state.pendingPagination.page
    const perPage = payload && payload.perPage ? payload.perPage : state.pendingPagination.perPage
    const q = payload && payload.q !== undefined ? payload.q : state.pendingPagination.q
    const qParam = q && q !== '' ? `&q=${encodeURIComponent(q)}` : ''
    if (state.pendingPagination.pagesLoaded[page] && q === state.pendingPagination.q) {
      return {
        reservations: [],
        meta: {
          page,
          per_page: perPage,
          total: state.pendingPagination.total,
          total_pages: state.pendingPagination.totalPages,
          q
        }
      }
    }
    const response = await endpoints.API.get(`${allReservationsUrl}?status=1&page=${page}&per_page=${perPage}${qParam}`
      , {
        headers: {
          Authorization: 'Bearer ' + token
        }
      })
    const {data: {message}} = response
    const reservations = message.reservations || []
    commit('APPEND_PENDING_RESERVATIONS', {reservations, meta: message.meta})
    return message
  },

  async resetPendingReservations({commit}, payload) {
    commit('RESET_PENDING_RESERVATIONS', payload || {})
  },

  async fetchAllApprovedReservations({commit, state}, payload) {
    const {allReservationsUrl, token} = state
    let allReservations = await endpoints.API.get(allReservationsUrl + '?status=2'
      , {
        headers: {
          Authorization: 'Bearer ' + token //the token is a variable which holds the token
        }
      })
    let {data: {message: {reservations}}} = allReservations
    return reservations;
  },

  async setIsLoading({commit, state}, payload) {
    commit('SET_IS_LOADING', payload)
  },

}

export default actions
